import { render, staticRenderFns } from "./newSafeQuality.vue?vue&type=template&id=ba20c26c&scoped=true&"
import script from "./newSafeQuality.vue?vue&type=script&lang=js&"
export * from "./newSafeQuality.vue?vue&type=script&lang=js&"
import style0 from "./newSafeQuality.vue?vue&type=style&index=0&id=ba20c26c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba20c26c",
  null
  
)

export default component.exports